(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.factory('severityTypes', function () {
        var data = [
            {
                autoId: 'policy_rule_edit_severity_dropdown_item_5',
                id: 5,
                label: 'Critical',
                color: '#cc4125'
            },
            {
                autoId: 'policy_rule_edit_severity_dropdown_item_4',
                id: 4,
                label: 'High',
                color: '#ed1c24'
            },
            {
                autoId: 'policy_rule_edit_severity_dropdown_item_3',
                id: 3,
                label: 'Medium',
                color: '#fec543'
            },
            {
                autoId: 'policy_rule_edit_severity_dropdown_item_2',
                id: 2,
                label: 'Low',
                color: '#43b4e3'
            },
            {
                autoId: 'policy_rule_edit_severity_dropdown_item_1',
                id: 1,
                label: 'Lowest',
                color: '#91ce55'
            }
        ];
        return {
            data: data,
            get: function (id) {
                var found = _(data).find(function (res) {
                    return res.id == id;
                });
                if (!found) {
                    return {
                        id: id,
                        label: id.charAt(0).toUpperCase() + id.slice(1)
                    };
                }
                return found;
            }
        };
    });
}());